import React from 'react';
import '../LandingPage/LandingPage.css';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-content-container">
        
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="about-logo">
            <path d="M15.578 9.01277C14.7616 8.19637 13.4808 8.03231 12.5632 8.73312C10.9429 9.97072 9.527 11.4624 8.37501 13.1487C7.74895 14.0651 7.93561 15.2837 8.72039 16.0685L15.4952 22.8433C16.227 23.5751 16.227 24.7614 15.4952 25.4932L8.95765 32.0308C8.15835 32.8301 7.98173 34.0772 8.6419 34.9948C9.83323 36.6506 11.2838 38.1075 12.9341 39.3059C13.8518 39.9723 15.1041 39.7976 15.9061 38.9957L20.7339 34.1679C21.7823 33.1194 22.3713 31.6974 22.3713 30.2147V18.1218C22.3713 16.6391 21.7823 15.2171 20.7339 14.1686L15.578 9.01277Z" fill="var(--text-primary)"/>
            <path d="M38.9815 32.4231C39.798 33.2397 39.962 34.5208 39.2607 35.4384C38.0227 37.0583 36.5306 38.4738 34.8439 39.6253C33.9275 40.251 32.7093 40.0642 31.9247 39.2796L26.8132 34.1682C25.7648 33.1198 25.1758 31.6978 25.1758 30.215V18.1221C25.1758 16.6394 25.7648 15.2174 26.8132 14.1689L32.2616 8.72062C33.0607 7.92148 34.3075 7.74475 35.2251 8.40454C36.8813 9.59545 38.3385 11.0456 39.5374 12.6957C40.2042 13.6133 40.0295 14.866 39.2274 15.668L32.0518 22.8436C31.3201 23.5754 31.3201 24.7618 32.0518 25.4935L38.9815 32.4231Z" fill="var(--text-primary)"/>
        </svg>

        <h1>About Us</h1>
        
        <section className="about-section">
          <h2>Company Information</h2>
          <p>
            <strong>Company Name:</strong> Designers Stash<br/>
            <strong>Founded in:</strong> Denmark<br/>
            <strong>CVR Number:</strong> 35502696 <br/>
            <strong>Official Registration:</strong>{" "}
            <a href="https://datacvr.virk.dk/enhed/virksomhed/35502696" target="_blank" rel="noopener noreferrer">
              View on Virk.dk
            </a>
          </p>
        </section>

        <section className="about-section">
          <h2>What We Do</h2>
          <p>
            Designers Stash is a software development company based in Denmark. Our primary focus is building Texta, a powerful platform designed to streamline writing, translation, and localization workflows for teams. Texta utilizes AI and collaborative tools to help businesses create consistent, high-quality content across multiple languages efficiently.
          </p>
        </section>
        
        
      </div>
    </div>
  );
};

export default AboutPage; 